import { EVENTS } from '../lib/constants';
import { GameConfigs } from '../lib/globals/GameConfigs';
import HELPERS from '../lib/globals/helpers/Helpers';

class SoundController {
	constructor(vc, conf) {
		this.vc = vc;
		this.config = conf;
		this.enabled = false;
		if (this.vc.infobuttons.getChildByName(this.config.soundon)) {
			this.soundon = this.vc.infobuttons.getChildByName(this.config.soundon);
			this.soundoff = this.vc.infobuttons.getChildByName(this.config.soundoff);
			this.soundon.handler = this.soundHandler;
			this.soundoff.handler = this.soundHandler;
			GameConfigs.settings.sound_effects ||
			GameConfigs.settings.background_music
				? (this.soundoff.alpha = 0)
				: (this.soundon.alpha = 0);
			window.addEventListener(EVENTS.SETTINGS_UPDATE, this, false);
			window.addEventListener(EVENTS.ERROR_PAGE, this, false);
			if (
				GameConfigs.settings.keyboard_shortcuts &&
				!window.isMobile &&
				!window.isTablet
			) {
				this.enabled = true;
				window.addEventListener('keydown', this, false);
			}
		} else {
			throw new Error(
				'SoundController failed init ' + JSON.stringify(this.config)
			);
		}
	}
	handleEvent(evt) {
		const data = evt.detail.data;
		switch (evt.type) {
			case EVENTS.SETTINGS_UPDATE:
				if (evt.detail.data.keyboard_shortcuts !== undefined) {
					if (evt.detail.data.keyboard_shortcuts) {
						if (this.enabled) return;
						this.enabled = true;
						window.addEventListener('keydown', this, false);
					} else {
						this.enabled = false;
						window.removeEventListener('keydown', this, false);
					}
				}

				if ('sound_effects' in data || 'background_music' in data) {
					if (
						(data.sound_effects === false &&
							GameConfigs.settings.background_music === false) ||
						(data.background_music === false &&
							GameConfigs.settings.sound_effects === false)
					) {
						this.soundOff();
					} else this.soundOn();
				}
				break;

			case 'keydown':
				if (evt.keyCode === 77) {
					this.soundHandler();
				}
				break;
			case EVENTS.ERROR_PAGE:
				this.removeEvents();
				break;
			default:
				break;
		}
	}

	soundHandler = () => {
		if (
			GameConfigs.settings.sound_effects ||
			GameConfigs.settings.background_music
		) {
			this.soundOff();
			GameConfigs.settings.sound_effects = false;
			GameConfigs.settings.background_music = false;
			HELPERS.setSettings({ sound_effects: false, background_music: false });
		} else {
			this.soundOn();
			GameConfigs.settings.sound_effects = true;
			GameConfigs.settings.background_music = true;
			HELPERS.setSettings({ sound_effects: true, background_music: true });
		}
	};

	soundOn() {
		this.soundoff.alpha = 0;
		this.soundon.alpha = 1;
	}

	soundOff() {
		this.soundon.alpha = 0;
		this.soundoff.alpha = 1;
	}

	removeEvents() {
		if (this.item) {
			this.item.interactive = false;
		}
		window.removeEventListener(EVENTS.ERROR_PAGE, this, false);
		window.removeEventListener(EVENTS.SETTINGS_UPDATE, this, false);
		window.removeEventListener(EVENTS.MODAL, this, false);
		window.removeEventListener('keydown', this, false);
	}
}

export default SoundController;
